import { scrollConfig } from "../constants/scrollerConfig";
import { scroller } from "react-scroll";

export const scrollTo = (elem) => {
  scroller.scrollTo(elem, scrollConfig);
};
